import { clearKeychain } from '@plug-core/handlers/walletActions/wallet'
import { useConnectionProvider } from '@plug-core/state'
import { disconnectII } from './internetIdentity'
import { disconnectOisy } from './oisy'
import { disconnectFromPlugExtension } from './plugExtension'

export const disconnect = async () => {
  const { provider } = useConnectionProvider.getState()
  const previousProvider = provider

  if (provider === 'plug') {
    await disconnectFromPlugExtension()
  } else if (provider === 'internet-identity-legacy' || provider === 'internet-identity-v2') {
    await disconnectII()
  } else if (provider === 'oisy') {
    await disconnectOisy()
  }

  await clearKeychain()
  useConnectionProvider.setState({ provider: null, previousProvider })

  window.location.reload()
}
